import createIcon from '../../createIcon';

/**
 * @component @name LiveHelp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMS41SDVDMy44OSAxLjUgMyAyLjQgMyAzLjVWMTcuNUMzIDE4LjYgMy44OSAxOS41IDUgMTkuNUg5TDEyIDIyLjVMMTUgMTkuNUgxOUMyMC4xIDE5LjUgMjEgMTguNiAyMSAxNy41VjMuNUMyMSAyLjQgMjAuMSAxLjUgMTkgMS41Wk0xMyAxNy41SDExVjE1LjVIMTNWMTcuNVpNMTUuMDcgOS43NUwxNC4xNyAxMC42N0MxMy40NSAxMS40IDEzIDEyIDEzIDEzLjVIMTFWMTNDMTEgMTEuOSAxMS40NSAxMC45IDEyLjE3IDEwLjE3TDEzLjQxIDguOTFDMTMuNzggOC41NSAxNCA4LjA1IDE0IDcuNUMxNCA2LjQgMTMuMSA1LjUgMTIgNS41QzEwLjkgNS41IDEwIDYuNCAxMCA3LjVIOEM4IDUuMjkgOS43OSAzLjUgMTIgMy41QzE0LjIxIDMuNSAxNiA1LjI5IDE2IDcuNUMxNiA4LjM4IDE1LjY0IDkuMTggMTUuMDcgOS43NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LiveHelp = createIcon('LiveHelp', [
  [
    'path',
    {
      d: 'M19 1.5H5C3.89 1.5 3 2.4 3 3.5V17.5C3 18.6 3.89 19.5 5 19.5H9L12 22.5L15 19.5H19C20.1 19.5 21 18.6 21 17.5V3.5C21 2.4 20.1 1.5 19 1.5ZM13 17.5H11V15.5H13V17.5ZM15.07 9.75L14.17 10.67C13.45 11.4 13 12 13 13.5H11V13C11 11.9 11.45 10.9 12.17 10.17L13.41 8.91C13.78 8.55 14 8.05 14 7.5C14 6.4 13.1 5.5 12 5.5C10.9 5.5 10 6.4 10 7.5H8C8 5.29 9.79 3.5 12 3.5C14.21 3.5 16 5.29 16 7.5C16 8.38 15.64 9.18 15.07 9.75Z',
      key: '7a7d1j',
    },
  ],
]);

export default LiveHelp;
